// extracted by mini-css-extract-plugin
export var numpadContainer = "_qc-1";
export var phoneButton = "_qc-0";